import AppDownloadButton from "@fuse/sharedComponents/legacyUI/AppDownloadButton"
import Bottom from "@fuse/sharedComponents/legacyUI/Bottom"
import BottomHalf from "@fuse/sharedComponents/legacyUI/BottomHalf"
import Testimonial from "@fuse/sharedComponents/legacyUI/Testimonial"
import { LetsHangDownloadHeader } from "@fuse/sharedComponents/legacyUI/Top/DownloadButton"
import {
  greyColor,
  headingStyle,
} from "@fuse/sharedComponents/legacyUI/Top/styles"
import FancyText from "@fuse/sharedComponents/typography/FancyText"

import First from "@fuse/assets/images/img-event-first.svg"

import { GroupReadyToHang } from "./GroupReadyToHang"

const EmptyGroupPageTop = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="md:mt-[78] mt-[50px] max-w-screen-xl mx-[30px] md:mx-[50px] lg:mx-[100px]">
        <LetsHangDownloadHeader />
        <div className="md:flex flex-1">
          <div className="flex-1 justify-between text-start mb-[73px] md:mb-[80px]">
            <FancyText
              style={headingStyle}
              className="text-[38px] md:text-[38px] lg:text-[48px] xl:text-[58px] space-[-0.658px] tracking-[-0.658px] "
            >
              Let's Hang Together! Your Group Invitation Awaits!
            </FancyText>
            <div className="my-[26px] md:my-[40px]">
              <FancyText
                className="text-[15px] md:text-[18px] mb-[10px] md:mb-[10px]"
                style={greyColor}
              >
                Hi there 👋
              </FancyText>
              <FancyText
                className="text-[15px] md:text-[18px] mb-[10px] md:mb-[10px]"
                style={greyColor}
              >
                You're Invited to Join a Group – Personalize Your Experience,
                Set the Vibe, Plan Activities, and Connect with Like-Minded
                Individuals.
              </FancyText>
              <FancyText
                className="text-[15px] md:text-[18px] mb-[10px] md:mb-[10px]"
                style={greyColor}
              >
                Download the app now and get ready to be part of a group!
              </FancyText>
            </div>
            <div className="flex flex-row mb-[40px]">
              <AppDownloadButton
                label={"Download now"}
                className="px-6 lg:px-8"
              />
            </div>
          </div>
          <div className="flex-1 lg:flex items-center justify-center">
            <img src={First} alt="First" className="hero-image" />
          </div>
        </div>
      </div>
    </div>
  )
}

const EmptyGroup = () => {
  return (
    <>
      <EmptyGroupPageTop />
      <BottomHalf />
      <GroupReadyToHang />
      <Testimonial />
      <Bottom />
    </>
  )
}

export default EmptyGroup
